module.exports = __webpack_public_path__ + "static/img/1-2.9096a53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/1-2.jpg
// module id = kWHE
// module chunks = 0